export default __webpack_public_path__ + "1186484d214788d8a35916b44bbd583b.svg";